import { Payment, PaymentMethod } from '@/models/Payment';
import { brands } from '@/support/Brands';
import { identifyHostname } from '@/support/Client';
import ErrorHandler from '@/support/ErrorHandler';
import { FormInput, PersonalInformationForm, startForm } from '@/support/Forms';
import { fileToBase64, formatDate, sanitizeString } from '@/support/String';
import { HTMLInputEvent } from '@/types/atabix';
import axios, { AxiosError } from 'axios';
import { DateTime } from 'luxon';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import VueTelInput from 'vue-tel-input';
import AddressHelper from '@/support/AddressHelper';
import { AddressCheck } from '@/models/AddressCheck';
import { Lead } from '@/models/Lead';
import { cloneDeep } from 'lodash';

@Component<Question>({
  components: {
    VueTelInput,
  },
})
export default class Question extends Vue {
  protected startForm: FormInput[] = startForm;
  protected personalInformationForm: FormInput[] = PersonalInformationForm;

  protected noPaazlOptions: boolean = false;

  protected countrySelectorTranslations= {
    countrySelectorLabel: 'Landcode',
    countrySelectorError: 'Selecteer een land',
    phoneNumberLabel: 'telefoonnummer',
    example: 'Voorbeeld :'
  }

  protected checkedItems = [];
  protected currentSlide: number = 0;
  protected carouselHeight: number = 200;
  protected agreement: boolean = false;
  protected emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  protected showLoader: boolean = false;
  protected showRedirectLoader: boolean = false;
  public oAuthServer: string = identifyHostname() || '';
  protected numberOfBrands: number = 20;

  protected deliveryOptionsDate: object[] = [];
  protected deliveryOptionsTime: object[] = [];

  protected chosenDelivery: boolean = false;
  protected newPayment = new Payment();
  protected hasPaymentMethodSelected: boolean = false;

  protected selectedDeliveryOptionDate: selectedOptionDate | null = null;
  protected selectedDeliveryOptionTime: selectedOptionTime | null = null;

  protected phone: string = '';
  protected phoneValid: boolean = false;

  protected referralCode = '';

  protected referralCodeErrors: string[] = [];

  protected selectedCountry: SelectedDate = {
    label: '',
    value: '',
  }

  protected selectedExtraCountry: SelectedDate = {
    label: '',
    value: '',
  }

  protected countries = [
    {
      label: 'Nederland',
      value: 'NL',
    },
    {
      label: 'Duitsland',
      value: 'DE',
    },
    {
      label: 'België',
      value: 'BE',
    }
  ]

  protected selectedDay: SelectedDate = {
    label: null,
    value: null,
  }

  protected selectedMonth: SelectedDate = {
    label: null,
    value: null,
  }

  protected selectedYear: SelectedDate = {
    label: null,
    value: null,
  }

  protected dateTimeModals = {
    deliveryDate: false,
    deliveryTime: false,
    birthday: {
      days: [],
      months: [],
      years: [],
    },
  }

  protected checkboxExtraAddress: boolean = false;

  get birthday(): string {
    const birthday = `${this.selectedYear.value}-${this.selectedMonth.value}-${this.selectedDay.value}`;
    return birthday;
  }

  protected fillDateTimeBirtday() {
    for (let index = 1; index < 32; index++) {
      (this.dateTimeModals.birthday.days as any).push({
        value: index < 10 ? `0${index}` : `${index}`,
        label: index < 10 ? `0${index}` : `${index}`,
      });
    }

    const monthsLabel = [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December'
    ];

    for (let index = 0; index <= monthsLabel.length - 1; index++) {
      (this.dateTimeModals.birthday.months as any).push({
        value: index < 9 ? `0${index + 1}` : `${index + 1}`,
        label: monthsLabel[index],
      });
    }

    const currentYear = DateTime.local().get('year');
    for (let index = 1920; index < currentYear - 17; index++) {
      (this.dateTimeModals.birthday.years as any).push({
        value: index,
        label: index,
      });
    }
    this.dateTimeModals.birthday.years.reverse();
  }

  protected dateTimes = {
    deliveryDate: null,
    deliveryTime: null,
  };

  protected fillSelectedCountry() {
    let country: SelectedDate = {
      label: '',
      value: '',
    }

    if (this.$store.getters.currentIpCountry === 'NL') {
      country.label = 'Nederland';
      country.value = 'NL';
    } else if (this.$store.getters.currentIpCountry === 'DE') {
      country.label = 'Duitsland';
      country.value = 'DE';
    } else if (this.$store.getters.currentIpCountry === 'BE') {
      country.label = 'België';
      country.value = 'BE';
    } else {
      country.label = 'Nederland';
      country.value = 'NL';
    }

    this.$nextTick(() => {
      this.$set(this, 'selectedCountry', country);
      this.$set(this, 'selectedExtraCountry', country);
      // START: Address API
      this.addressHelper.country = `${country.value}`;
      this.addressExtraHelper.country = `${country.value}`;
      // END: Address API
    });
  }

  @Prop({ default: undefined })
  protected answerToEdit!: any;

  @Prop({ default: false })
  protected question!: QuestionObject;

  @Prop({ default: true })
  protected isExistingQuestion!: boolean;

  @Prop({ default: false })
  protected showCheckIcon!: boolean;

  @Prop()
  protected questionIndex!: Number;

  @Prop()
  protected leadId!: string;

  @Prop()
  protected lead!: Lead;

  @Prop({ default: false })
  protected dialogOpen!: boolean;

  @Prop({ default: false })
  protected leadPayload!: Object;

  protected animate: boolean = false;
  protected selectedCheckboxes: object[] = [];
  protected selectedRadiobutton: object[] = [];
  protected textAreaValue: string = '';
  protected answeredInputRows: object = {};
  protected selected: object = {};
  protected answeredAgreeDisagree: object = {};

  protected isReferralValid = false;

  protected textAreaContent: string = '';
  protected selectedBodyType: SelectedBodyType = {
    bodyType: 'figuur 0',
  };

  protected bodyTypeMap = {
    0: 'figuur 0',
    1: 'figuur 1',
    2: 'figuur 2',
    3: 'figuur 3',
    4: 'figuur 4',
  };

  protected resizeSettings = {
    max_width: 1024,
    max_height: 1024,
  };

  protected nonExistentQuestionError = 'Deze vraag bestaat helaas niet meer in de stijlquiz.'

  protected selectedBrands: Brand[] = [];
  protected items: Brand[] = [];
  protected leadImages: string[] = [];

  // payment methods
  protected paymentMethods: PaymentMethod[] | null = null;

  // START: Address API
  private addressHelper = new AddressHelper();
  private addressExtraHelper = new AddressHelper();
  // END: Address API

  public async mounted(): Promise<void> {
    // START: Address API
    this.addressHelper.setAddressMethod = this.setAddress;
    this.addressExtraHelper.setAddressMethod =this.setAddress;
    this.addressExtraHelper.isExtra = true;
    // END: Address API

    this.items = brands;

    this.fillDateTimeBirtday();
    this.calculateHeight();

    // await timeout
    await new Promise((resolve) => setTimeout(() => {
      this.fillSelectedCountry();

      resolve(null);
    }, 300));

    this.prefillAnswerIfEditing();

    this.$nextTick((): void => {
      this.setReferralCode();
    });
  }

  protected setReferralCode(): void {
    const code = this.$route.query.referral_code;

    this.referralCode = code ? code as string : '';
    this.onChangeReferralCode();
  }

  protected prefillAnswerIfEditing(): void {
    if (this.answerToEdit !== undefined) {
      this.fillAnswer(this.answerToEdit);
    }
  }

  protected handleClickPaymentMethod(selectedPaymentMethod: PaymentMethod) {
    if (!this.paymentMethods || this.hasPaymentMethodSelected) {
      return;
    }

    if (selectedPaymentMethod.issuers && selectedPaymentMethod.issuers.length) {
      // handle issuers -> hide/show issuers if available
      this.togglePaymentMethod(selectedPaymentMethod);
    } else {
      // handle payment -> emit the chosen payment to the parent
      this.hasPaymentMethodSelected = true;
      this.questionAnswered(selectedPaymentMethod, 'payment-question_1', 'payment-question');
    }
  }

  protected getInputRows3Answer(key: string): string {
    return (this.answeredInputRows as any)[key].replaceAll('.', '').replaceAll(',', '.').replaceAll('€', '').trim();
  }

  protected onInputRows3Answer(event: HTMLInputEvent, key: string): void {
    const target = (event.target as HTMLInputElement);
    (this.answeredInputRows as any)[key] = `€ ${target.value ? target.value.replaceAll('.', ',') : ''}`;
  }

  protected onChangeReferralCode() {
    if (!this.referralCode) {
      return;
    }

    this.isReferralValid = false;
    this.referralCodeErrors = [];

    this.lead
      .update({ used_referral_code: this.referralCode })
      .then(() => {
        this.isReferralValid = true;
      })
      .catch((error: AxiosError) => {
        this.referralCodeErrors = error.response && error.response.data && error.response.data.errors && error.response.data.errors.used_referral_code ? error.response.data.errors.used_referral_code : [];
      });
  }

  protected togglePaymentMethod(selectedPaymentMethod: PaymentMethod) {
    if (!this.paymentMethods) {
      return;
    }

    const foundPaymentMethod = this.paymentMethods.find((paymentMethod: PaymentMethod) => {
      return selectedPaymentMethod.id === paymentMethod.id;
    });

    if (foundPaymentMethod) {
      if (foundPaymentMethod.active) {
        this.$set(foundPaymentMethod, 'active', false);
      } else {
        this.$set(foundPaymentMethod, 'active', true);
      }
    }
  }

  protected personalFormErrorMessagesHTML: any = [
    {
      name: 'email',
      value: '',
    },
    {
      name: 'birthday_at',
      value: '',
    },
    {
      name: 'phone',
      value: '',
    },
  ]

  protected isFormValid(form: FormInput[]) {
    let isValid = true;

    form.forEach((input: FormInput) => {
      if (!input.required) {
        return;
      }

      if (typeof input.value !== 'boolean' && input.name === 'email') {
        const foundForm = this.findFormError(input);
        if (!this.validateEmail(input.value)) {
          isValid = false;
        }

        !this.validateEmail(input.value) ? foundForm.value = 'De opgegeven email is ongeldig.' : foundForm.value = '';
      } else if (input.name === 'birthday_at') {
        const foundForm = this.findFormError(input);
        const dt = DateTime.fromObject({ year: Number(this.selectedYear.value), month: Number(this.selectedMonth.value), day: Number(this.selectedDay.value) });
        if ((this.birthday.length !== 10)) {
          isValid = false;

        }
        if (!dt.isValid) {
          isValid = false;

        }
        !this.birthdayIsValid ? foundForm.value = 'Je moet minstens 18 jaar oud zijn om bij ons een box te bestellen.' : foundForm.value = '';
      } else if (input.name === 'phone') {
        const foundForm = this.findFormError(input);
        if (!this.phoneValid) {
          isValid = false;

        }
        !this.phoneValid ? foundForm.value = 'Het telefoonnummer klopt nog niet.' : foundForm.value = '';
      } else {
        if (typeof input.value !== 'boolean' && !input.value.length) {
          isValid = false;
        }
      }
    });

    return isValid;
  }

  protected findFormError(input: FormInput) {
    return this.personalFormErrorMessagesHTML.find((form: any) => {
      return form.name === input.name;
    });
  }

  protected get birthdayIsValid(): boolean {
    if (!this.selectedYear.value || !this.selectedMonth.value || !this.selectedDay.value) {
      return false;
    }

    return this.age && this.age >= 18 ? true : false;
  }

  protected get age() {
    if (!this.selectedYear.value || !this.selectedMonth.value || !this.selectedDay.value) {
      return;
    }

    const selectedDate = DateTime.fromObject({
      year: Number(this.selectedYear.value),
      month: Number(this.selectedMonth.value),
      day: Number(this.selectedDay.value)
    });

    return this.formatBirthday(selectedDate.toFormat('yyyy-LL-dd'));
  }

  protected get currentIpCountry() {
    return this.$store.getters.currentIpCountry || '';
  }

  formatBirthday(date: string) {
    if (!date) {
      return '';
    }

    const birthday = DateTime.fromFormat(date, 'yyyy-LL-dd');
    if (!birthday.isValid) {
      return date;
    }

    const now = DateTime.local();
    return Math.floor((Math.abs(birthday.diff(now, 'years').toObject().years || 0)));
  }

  protected santizeString(value: string) {
    if (!value) {
      return '';
    }

    return sanitizeString(value, true);
  }

  protected validateEmail(input: string) {
    if (input === undefined) {
      return;
    }
    return this.emailRegex.test(input);
  }

  protected handleSlideChange(slideIndex: number) {
    this.currentSlide = slideIndex;
    this.selectedBodyType['bodyType'] = (this.bodyTypeMap as any)[slideIndex];
  }

  protected answerQuestion() {
    this.$emit('answeredQuestion', 'answer');
  }

  protected removeImage(index: number) {
    this.$emit('removeUploadedImage', this.leadImages[index]);
    this.leadImages.splice(index, 1);
  }

  protected checkForSelection(maxSelection: number) {
    if (this.selectedCheckboxes.length > maxSelection) {
      this.selectedCheckboxes.pop();
    }
  }

  protected onTap(event: any, value: any, key: string, type: string) {
    event.target.classList.add('touched')

    setTimeout(() => {
      event.target.classList.remove('touched')
      this.questionAnswered(value, key, type);
    }, 200)
  }

  protected invoiceCheckboxChange(checked: boolean) {
    this.checkboxExtraAddress = checked;
  }

  get computedDateFormatted() {
    const birthdate = this.getFormInputByName(this.personalInformationForm, 'birthday_at');

    if (!birthdate) {
      return '';
    }

    birthdate.value = this.birthday;
    return birthdate;
  }

  get computedCountry() {
    const country = this.getFormInputByName(this.personalInformationForm, 'country');

    if (!country) {
      return '';
    }
    country.value = (this.selectedCountry.label as string);
    return country;
  }

  get computedExtraCountry() {
    const country = this.getFormInputByName(this.personalInformationForm, 'extra_country');

    if (!country) {
      return '';
    }
    country.value = (this.selectedExtraCountry.label as string);
    return country;
  }

  // START: Address API
  private setAddress(addressCheck: AddressCheck | null, isExtra: boolean): void {
    const street = this.getFormInputByName(this.personalInformationForm, isExtra ? 'extra_street' : 'street');
    const city = this.getFormInputByName(this.personalInformationForm, isExtra ? 'extra_city' : 'city');

    if (street) { street.value = addressCheck && addressCheck.streetName ? addressCheck.streetName : ''; }
    if (city) { city.value = addressCheck && addressCheck.city ? addressCheck.city : ''; }

    // Make sure to reset question custom_address_input to false
    this.addressHelper.editToggleValue = false;
  }
  // END: Address API

  protected inputChanged(event: HTMLInputEvent) {
    if (this.isEmpty(event)) {
      return;
    }

    const file: File = (event.target.files as any)[0];

    fileToBase64(file).then((encodedFile: string) => {
      const image = new Image;
      (image as any).onload = () => {
        this.createCanvas(image, encodedFile);
      };
      image.src = encodedFile;
      this.clearFileInput(event.target);
    });
  }

  createCanvas(image: HTMLImageElement, encodedFile: string) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const canvasResize = document.createElement('canvas');
    const ctxResize = canvasResize.getContext('2d');
    let ratio = 1;

    if (!ctx || !ctxResize) {
      return;
    }

    if (image.naturalWidth > this.resizeSettings.max_width) {
      ratio = this.resizeSettings.max_width / image.naturalWidth;
    } else if (image.naturalHeight > this.resizeSettings.max_height) {
      ratio = this.resizeSettings.max_height / image.naturalHeight;
    }

    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    (ctx).drawImage(image, 0, 0);

    canvasResize.width = image.naturalWidth * ratio;
    canvasResize.height = image.naturalHeight * ratio;
    ctxResize.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, canvasResize.width, canvasResize.height);

    const compressed = canvasResize.toDataURL('image/jpeg', 0.5);
    this.leadImages.push(compressed);
  }

  protected isEmpty(event: HTMLInputEvent) {
    if (event.target === null || event.target.files === null || !event.target.files.length) {
      return true;
    }

    return false;
  }

  protected clearFileInput(fileInput: HTMLInputElement) {
    if (fileInput) {
      fileInput.removeAttribute('value');
      fileInput.setAttribute('value', '');
    }
  }

  parseInputRows(value: any, key: any) {
    let rowAnswers: any[] = [];
    Object.keys(this.answeredInputRows).forEach((key: any) => {
      const item = {
        key: key,
        value: (this.answeredInputRows as any)[key]
      }
      rowAnswers.push(item);
    });

    return rowAnswers;
  }

  parseInputForm(value: any) {
    let startFormRows: any = {};
    value.forEach((item: any) => {
      if (item['name'] === 'phone') {
        startFormRows[item['name']] = this.phone;
      } else {
        startFormRows[item['name']] = item['value'];
      }
    });

    return startFormRows;
  }

  protected questionAnswered(value: any, key: string, type: string) {
    const payload: QuestionPayload = {
      value,
      key,
      type,
    };

    if (type === 'input-rows') {
      payload.value = this.parseInputRows(value, key);
    } else if (type === 'body-figure') {
      payload.value = this.selectedBodyType['bodyType'];
    } else if (type === 'shipping-data-form') {
      payload.value = {
        delivery_at: `${this.selectedDeliveryOptionDate ? this.selectedDeliveryOptionDate.day : ''} ${this.selectedDeliveryOptionTime ? this.selectedDeliveryOptionTime.time : ''}`,
        paazl_delivery_option: this.selectedDeliveryOptionTime ? this.selectedDeliveryOptionTime.type : '',
      }
    } else if (type === 'start-form' || type === 'personal-data-form') {
      value.forEach((item: any) => {
        this.personalInformationForm.forEach((personalItem: any) => {
          if (item.name === personalItem.name) {
            personalItem.value = item.value;
          }
        });

        payload.value = this.parseInputForm(value);
      });
    } else if (type === 'final-question') {
      payload.value = value;
    }

    this.$emit('questionAnswered', payload);
    this.clear();
    this.animateFade();
  }

  protected clear() {
    this.selectedCheckboxes = [];
    this.selectedRadiobutton = [];
    this.answeredInputRows = {};
    this.answeredAgreeDisagree = {};
    this.currentSlide = 0;
    this.selected = {};

    if (this.isExistingQuestion) {
      this.leadImages = [];
    }

    // this.personalInformationForm = {};
    this.selectedBodyType = {
      bodyType: 'figuur 0',
    };
  }

  protected changeSlide(index: number) {
    (this.$refs.carousel as any).goSlide(index);
  }

  protected animateFade() {
    this.animate = true;
    setTimeout(() => {
      this.animate = false;
    }, 600);
  }

  protected nextQuestion() {
    this.$emit('skipToNext', 'answer');
  }

  protected goToQuestion(category: string, key: string) {
    this.$emit('goToQuestion', { category, key });
  }

  protected removeBrand(brand: Brand) {
    this.selectedBrands = this.selectedBrands.filter((item: Brand) => {
      return item.value !== brand.value;
    });
  }

  protected parseInputAnswers(answer: any) {
    let answerArray: any = [];
    answer.value.forEach((input: any) => {
      answerArray[input.key] = input.value;
    });
    return answerArray;
  }

  protected fillAnswer(answer: any) {
    this.clear();
    switch (answer.type) {
      case 'checkbox-list':
        this.selectedCheckboxes = answer.value;
        break;
      case 'final-question':
        this.selectedCheckboxes = answer.value;
        break;
      case 'radio-list-boxes':
        this.selectedRadiobutton = answer.value;
        break;
      case 'radio-list-pill':
        this.answeredInputRows = answer.value;
        break;
      case 'agree-disagree':
        this.answeredInputRows = answer.value;
        break;
      case 'input-rows':
        this.answeredInputRows = this.parseInputAnswers(answer);
        break;
      case 'dropdown-rows':
        this.selected = answer.value;
        break;
      case 'personal-data-form':
        /**
         * @description Step 1 where one can fill out 'name' and 'email', is skipped (by client request), we pass anonimous data on that step (e.g. first_name: anonimous, last_name: anonimous, email: anonimous+123456789@maison.nl)
         * @description Because of the above, on the step of the personalInformationForm, that dummy data needs to be cleared if it occurs
         */
        this.personalInformationForm = this.removeAnonimousData(answer.value);
        break;
      case 'start-form':
        this.startForm = answer.value;
        break;
      case 'textarea':
        this.textAreaValue = answer.value;
        break;
      case 'auto-complete':
        this.selectedBrands = answer.value;

      default:
        break;
    }
  }

  /**
   * @description Step 1 where one can fill out 'name' and 'email', is skipped (by client request), we pass anonimous data on that step (e.g. first_name: anonimous, last_name: anonimous, email: anonimous+123456789@maison.nl)
   * @description Because of the above, on the step of the personalInformationForm, that dummy data needs to be cleared if it occurs
   */
  protected removeAnonimousData(value: any): any {
    const { email, first_name, last_name, ...rest } = value;

    return {
      ...rest,

      email: typeof email === 'string' && email.includes('anoniem+') && email.includes('@maison365.nl')
        ? ''
        : email,

      first_name: first_name === 'anoniem' || first_name === 'Anoniem'
        ? ''
        : first_name,

      last_name: last_name === 'anoniem' ||  last_name === 'Anoniem'
        ? ''
        : last_name,
    };
  }

  protected fetchLeadContactInformation() {
    /**
     * @description Step 1 where one can fill out 'name' and 'email', is skipped (by client request), we pass anonimous data on that step (e.g. first_name: anonimous, last_name: anonimous, email: anonimous+123456789@maison.nl)
     * @description Because of the above, on the step of the personalInformationForm, that dummy data needs to be cleared if it occurs
     */
    const lead = this.removeAnonimousData(cloneDeep(this.$store.state.lead));
    if (!lead) {
      return;
    }
    this.personalInformationForm.forEach((formInput: FormInput) => {
      if (!lead[formInput.name]) {
        return;
      }

      formInput.value = lead[formInput.name];

      if (formInput.name === 'phone') {
        this.phone = lead[formInput.name];
        this.phoneValid = true;
      }

      if (formInput.name === 'birthday_at') {
        this.selectedDay.value = formatDate(lead[formInput.name], 'dd');
        this.selectedMonth.value = formatDate(lead[formInput.name], 'LL');
        this.selectedYear.value = Number(formatDate(lead[formInput.name], 'yyyy'));
      }
    });
  }

  private fetchAnswer() {
    const leadAnswers = this.$store.state.leadAnswers;
    if (!leadAnswers || !leadAnswers.answers) {
      return;
    }
    if (typeof leadAnswers.answers === 'string') {
      return;
    }
    const answer = leadAnswers.answers.find((element: any) => {
      return (this.question as any).key === element.key;
    });

    if (answer) {
      this.fillAnswer(answer);
    }
  }

  protected fillImages() {
    const leadAnswers = this.$store.state.leadAnswers;
    if (!leadAnswers.images) {
      return;
    }

    this.leadImages = [...leadAnswers.images];
  }

  protected getAxiosClient() {
    const headers = {};
    const axiosClient = axios.create({
      baseURL: this.oAuthServer,
      headers,
    });
    return axiosClient;
  }

  protected getPaazlDeliveryDate() {
    this.showLoader = true;
    const client = this.getAxiosClient();
    client
      .get(`/v1/leads/delivery-options/${this.leadId}?zip_code=${this.$store.state.leadAnswers.zip_code}`)
      .then((response: any) => {
        if (!response.data.delivery.length) {
          this.noPaazlOptions = true;
        }
        this.deliveryOptionsDate = response.data.delivery;
        this.showLoader = false;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        this.showLoader = false;
      });
  }

  protected getFormInputByName(form: FormInput[], name: string) {
    return form.find((formInput: FormInput) => {
      return formInput.name === name;
    });
  }

  protected onPhoneInput(phoneInput: PhoneNumber) {
    this.phone = phoneInput.number;
    this.phoneValid = phoneInput.isValid;
  }

  protected clearShippingInformation() {
    this.selectedDeliveryOptionDate = null;
    this.selectedDeliveryOptionTime = null;
    this.deliveryOptionsDate = [];
    this.deliveryOptionsTime = [];
    this.noPaazlOptions = false;
  }

  protected handleBlur(event: any, question: QuestionObject) {
    if (!event || !event.target) {
      return;
    }

    !event.target.value && question.required ? question.empty = true : question.empty = false;
  }

  protected handleInput(event: any, question: QuestionObject) {
    if (!event || !event.target) {
      return;
    }

    !event.target.value && question.required ? question.empty = true : question.empty = false;
  }

  protected calculateHeight() {
    if (this.$refs && this.$refs.reviewMessage) {
      const messages = this.$refs.reviewMessage as [];
      const reviewHeights: number[] = [];
      messages.map((message: any) => {
        reviewHeights.push(message.offsetHeight);
      });

      this.carouselHeight = Math.max(...reviewHeights)

      if (screen.width <= 760) {
        this.carouselHeight = 800;
      } else {
        this.carouselHeight = 200;
      }
    }
  }

  /**
   * Set the question id
   * Useful for our marketing tools
   *
   * @param type
   * @param index
   * @param subIndex
   */
  protected getQuestionId(type: string, index: number = 0, subIndex: number = 0) {
    return `question-${type}-${index}-${subIndex}-${this.questionIndex}`;
  }

  @Watch('question.type')
  protected questionTypeChanged(newValue: string) {
    if (newValue === 'reviews') {
      setTimeout(() => {
        this.calculateHeight();
      }, 50);
    }
  }

  @Watch('selectedDeliveryOptionDate', { deep: true })
  protected selectedDelivery() {
    if (this.selectedDeliveryOptionDate) {
      this.deliveryOptionsTime = this.selectedDeliveryOptionDate.times;
    }
  }

  @Watch('selectedDeliveryOptionTime', { deep: true })
  protected selectedDeliveryTime() {
    this.chosenDelivery = true;
    if (!this.selectedDeliveryOptionDate) {
      this.chosenDelivery = false;
    }
  }

  @Watch('questionIndex')
  protected questionChanged(newQuestionIndex: number, oldQuestionIndex: number) {
    if (this.question.type === 'shipping-data-form') {
      this.getPaazlDeliveryDate();
      this.clearShippingInformation();
    }

    if (this.question.type === 'upload-file') {
      this.fillImages();
    } else {
      this.fetchAnswer();
      this.fetchLeadContactInformation();
    }
  }

  @Watch('dialogOpen')
  protected dialogChanged(newDialogValue: boolean) {
    if (newDialogValue) {
      this.fetchAnswer();
      this.fetchLeadContactInformation();
    }
  }
}

interface PhoneNumber {
  number: string;
  isValid: boolean;
  country: object;
}

interface Brand {
  label: string;
  value: string;
}

interface QuestionPayload {
  value: any;
  key: string;
  type: string;
  contact_method?: object;
}

interface countryNumber {
  label: string;
  value: string;
  icon: string;
}

interface QuestionObject {
  type: string;
  empty: boolean;
  required: boolean;
  key: string;
}

interface SelectedBodyType {
  bodyType: string;
}

interface selectedOptionDate {
  day: string;
  text: string;
  times: object[];
}

interface selectedOptionTime {
  type: string;
  time: string;
  time_span: string;
  text: string;
}

interface SelectedDate {
  label: null | number | string;
  value: null | number | string;
}
